export default __webpack_public_path__ + "static/media/cwPosLogo.a3520edb.png";